import React from 'react';
import Helmet from 'react-helmet';
import {Route,Switch,Redirect,useLocation} from 'react-router-dom';
import PropTypes from 'prop-types';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

import Typography from '@mui/material/Typography';

import CircularProgress from '@mui/material/CircularProgress';
import queryString from 'query-string';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';


import APIs from 'flexbiz-api';
import './App.css';
import getTheme from "./Theme";

import Meta from './components/Meta';
import SigninProvider from './components/auth/Provider';
import {QuickActionProvider} from './components/DataQuickActionContext';

import {ModalManagerProvider} from './components/ModalManagerContext';

import NotificationProvider from './components/auth/NotificationProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Layout from './components/AppLayout';
function AppLayout({ routes }) {
  const location = useLocation();
  const state_props = (location.state?.props || {});
  //
  return (
    <Layout>
      <Switch location={location}>
        {(routes || []).filter(r => !r.parent).map(route => {
          return (
            <Route
              key={route.path}
              exact={route.exact}
              path={route.path}
              render={(props) => {
                const RouteContent = route.render 
                  ? route.render(props) 
                  : <route.component {...props} {...state_props} />;
                return RouteContent;
              }}
            />
          );
        })}

        {/* Bắt tất cả các đường dẫn không tồn tại và chuyển hướng về /404 */}
        <Redirect to="/404" />
      </Switch>
    </Layout>
    
  );
}

class App extends React.PureComponent {
  constructor(props){
    super(props);
    //config
    let config = this.config = (this.props.config||{});
    config.routes = config.routes || this.props.routes || []; 
    //get query params
    if(!config.queryParams){
      let queryParams={};
      if(typeof window !== 'undefined'){
        config.home_url = window.location.href;
        queryParams = queryString.parse(window.location.search);
        let ps = (window.location.href.split("#/"));
        if(ps.length>1){
          let localHref = ps[1];
          if(localHref.indexOf("?")>=0){
            const params2 = queryString.parse(localHref.split("?")[1]);
            queryParams = {...params2,...queryParams};
          }
        }
        
        if( queryParams.id_app=="undefined"){
          delete queryParams.id_app
        }

        //id_app
        let _id_app = queryParams.id_app;
        if(_id_app){
          config.id_app = config.default_id_app = _id_app;
          localStorage.setItem("id_app",_id_app);
          config.id_app_dynamic = false;
          //group user default
          let _group_id = queryParams.user_group_id;
          if(_group_id){
            config.group_id = _group_id;
          }
        }
        
        //name_app
        if(queryParams.app_name){
          config.app_name = config.app_name_en  = queryParams.app_name;
        }
        config.queryParams = queryParams;
      }
    }

    //custom theme
    config.isMobile = config.queryParams?.is_mobile || config.queryParams?.for_agent || window.innerWidth<520;
    this.theme = getTheme(config);
    //create APIs
    this.apis = new APIs(this.config);
    let language_loaded = (this.config.multi_lang || this.config.queryParams.multi_lang)?false:true
    if(language_loaded) localStorage.setItem("lang","vi");
    
    this.state={
      language_loaded
    }
  }
  async componentDidMount(){
    if(!this.state.language_loaded){
      await this.apis.asyncLoadLang();
      await this.apis.getLabelsList();
      this.setState({language_loaded:true});
    }else{
      await this.apis.asyncLoadLang();
      this.apis.getLabelsList();
    }
  }
  render(){
    if(!this.state.language_loaded){
      return <div style={{width:"100vw",height:"100vh",display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",backgroundColor:"white"}}>
        <div style={{display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center",padding:10,borderRadius:5,backgroundColor:"transparent"}}>
          <CircularProgress style={{color: (this.config.primaryColor || "blue"),width:48,height:48}}/>
          <div style={{textAlign:"center"}}><Typography variant="caption">Preparing the language package</Typography></div>
        </div>
      </div>
    }
    const {routes} = this.config;
    let Provider = this.props.provider || SigninProvider;
    let NotifyProvider = this.props.notifyProvider || NotificationProvider;
    let style ={opacity:this.props.opacity===undefined?1:this.props.opacity}
    let className = "flex-container";
    if(this.config.queryParams && this.config.queryParams.for_agent){
      className = "flex-container-agent"
    }
    const queryClient = new QueryClient();
    return (
      <div id="app-container" style={style} class={className}>
        
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={this.theme}>
              <ModalManagerProvider>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <QueryClientProvider client={queryClient}>
                    <Provider config ={this.config} apis={this.apis} sysForms={this.props.sysForms}>
                      <QuickActionProvider>
                        <NotifyProvider>
                          <Helmet title={this.config.app_title}/>
                          <Meta/>
                          <AppLayout routes ={routes}/>
                        </NotifyProvider>
                      </QuickActionProvider>
                    </Provider>
                    </QueryClientProvider>
                </LocalizationProvider>
              </ModalManagerProvider>
            </ThemeProvider>
          </StyledEngineProvider>
        
      </div>
    );
  }
}
App.propTypes={
  opacity:PropTypes.bool,
  config:PropTypes.object.isRequired,
  sysForms:PropTypes.any,
  provider:PropTypes.any,
  onNotifyClick:PropTypes.func,
}
export default App;
